import React from 'react';
import {
    Row, message
} from 'antd';

import Header from './Header';


import {
    setInfoKamar, getFontConfig,
} from '../localstorage/config';

import mousetrap from 'mousetrap';
import SettingDrawer from './SettingDrawer';

import MyModalError from './MyModalError';
import MyCarousel from './MyCarousel';
import { websocket } from '../config';

class Display extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            panel_setting: false,
            socket_status: false,
            ukuranFont: 14
        }
    }

    openSetting = (e) => {
        e.preventDefault();
        this.closePanelSetting();
    }

    componentDidMount = () => {
        mousetrap.bind('alt+s', this.openSetting);
        //this.wsConnect();
        let refreshTime = 1000 * 60 * 30;
        this.intervalId = setInterval(this.refreshPage, refreshTime);
        this.setFont();
    }

    setFont = () => {
        const fontSize = getFontConfig();
        if (typeof fontSize !== 'undefined') {
            this.setState({
                ukuranFont: fontSize
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    refreshPage = () => {
        window.location.reload(true);
    }

    setLokalInfoKamar = async (val) => {
        var setStatus = await setInfoKamar(val.list);
        if (setStatus) {
            return true;
        }
    }

    closePanelSetting = () => {
        this.setState({
            panel_setting: this.state.panel_setting ? false : true
        })
    }

    OnOkModalError = () => {
        this.setState({
            modal_error: false
        });
    }

    wsConnect = () => {
        this.conn = new WebSocket(websocket);
        this.conn.onopen = (e) => {
            console.log("Koneksi websocket terhubung!");
            this.setState({
                socket_status: true
            })
        }

        this.conn.onerror = (e) => {
            console.log('server socket error');
            this.setState({
                socket_status: false
            })
        }

        this.conn.onmessage = (e) => {
            var response = JSON.parse(e.data);
            const success = () => {
                message.loading('Request ' + response.details.path_info + ' in progress..', 0);
                // Dismiss manually and asynchronously
                if (response.type === 'onResponse') {
                    switch (response.details.path_info) {
                        case '/application/update':
                            this.refreshPage();
                            break;
                        case '/application/updateReset':
                            localStorage.removeItem('configApp');
                            this.refreshPage();
                            break;

                        default:
                            break;
                    };
                    message.destroy();
                    // message.info('Finished.', 2.5);
                }
            };
            success();
        };

        this.conn.onclose = (e) => {
            console.log('Socket is closed. Reconnect will be attempted in 5 second.', e.reason);
            setTimeout(() => {
                this.wsConnect();
            }, 5000);
        }
    }

    render() {
        const { ukuranFont, panel_setting, modal_error } = this.state;
        return (
            <div style={{
                padding: 0
            }} >
                <Row style={{
                    fontSize: ukuranFont
                }}>
                    <div onClick={this.openSetting}>
                        <Header />
                    </div>
                </Row>
                <Row style={{
                    fontSize: ukuranFont
                }}>
                    <MyCarousel />
                </Row>
                <SettingDrawer
                    visible={panel_setting}
                    onClose={this.closePanelSetting}
                />
                {
                    modal_error ? <MyModalError
                        visible={modal_error}
                        onOk={this.OnOkModalError}
                        onCancel={this.OnOkModalError}
                        onAction={this.fetchFirst}
                    /> : <div></div>
                }

            </div >
        );
    }
};



export default Display;